import React, { useState } from "react";
import { authApi, formatApiError } from "./api";
import { Building2, Lock, Eye, EyeOff, ArrowRight, ShieldCheck, CheckCircle2 } from "lucide-react";

const HERO = "https://static.prod-images.emergentagent.com/jobs/6e81a1f9-3916-4b76-bbad-ad2e99a330b5/images/ee312c06fa4a60f9e205e900828d47204131151ae3171a3b19e01344ccc2c9e7.jpeg";

export default function ResetPassword({ token }: { token: string | null }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const goLogin = () => { window.location.href = "/"; };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    if (!token) { setErr("Link reset tidak valid."); return; }
    if (password.length < 6) { setErr("Password minimal 6 karakter."); return; }
    if (password !== confirm) { setErr("Konfirmasi password tidak cocok."); return; }
    setBusy(true);
    try {
      await authApi.resetPassword(token, password);
      setDone(true);
    } catch (ex: any) {
      setErr(formatApiError(ex?.detail) || "Gagal mengatur ulang password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lg-root" data-theme="light">
      <aside className="lg-hero" style={{ backgroundImage: `url(${HERO})` }}>
        <div className="lg-hero-overlay" />
        <div className="lg-hero-content">
          <div className="lg-hero-top">
            <div className="lg-logo">
              <Building2 className="lg-logo-mark" size={30} strokeWidth={2.2} />
              <div className="lg-logo-text">
                <span className="lg-wordmark">STRUKTURKU</span>
                <span className="lg-tagline">by Abadi Premium Consultant</span>
              </div>
            </div>
            <div className="lg-rule" />
            <h1 className="lg-headline serif">Atur Ulang<br /><span className="lg-headline-accent">Password Anda.</span></h1>
            <p className="lg-desc">Buat password baru yang aman untuk melanjutkan bekerja di Strukturku.</p>
          </div>
          <div className="lg-hero-foot"><span className="lg-foot-line" />DARI DOKUMEN AKTA<br />MENUJU KEPUTUSAN YANG LEBIH BAIK.</div>
        </div>
      </aside>

      <main className="lg-form-side">
        <div className="lg-form-wrap">
          <div className="lg-form-brand">
            <Building2 className="lg-brand-mark" size={40} strokeWidth={2.2} />
            <span className="lg-brand-word">STRUKTURKU</span>
            <span className="lg-brand-sub">by Abadi Premium Consultant</span>
          </div>
          <h2 className="lg-welcome serif">Password Baru</h2>
          <p className="lg-welcome-sub">Masukkan password baru untuk akun Anda.</p>

          {done ? (
            <div className="lg-forgot-done">
              <div className="lg-info" data-testid="reset-success">
                <CheckCircle2 size={17} strokeWidth={2} style={{ flexShrink: 0, marginTop: 1 }} />
                <span>Password berhasil diperbarui. Silakan masuk dengan password baru Anda.</span>
              </div>
              <button className="lg-submit" onClick={goLogin} data-testid="reset-go-login">
                Ke Halaman Masuk <ArrowRight size={18} strokeWidth={2.4} />
              </button>
            </div>
          ) : (
            <form className="lg-form" onSubmit={submit}>
              <div className="lg-field">
                <label>Password Baru</label>
                <div className="lg-input">
                  <Lock className="lg-input-ic" size={18} strokeWidth={1.8} />
                  <input data-testid="reset-password" type={showPass ? "text" : "password"} required value={password}
                    onChange={(e) => setPassword(e.target.value)} placeholder="Minimal 6 karakter" autoComplete="new-password" />
                  <button type="button" className="lg-eye" onClick={() => setShowPass((s) => !s)} data-testid="reset-toggle-password" aria-label="Tampilkan password">
                    {showPass ? <EyeOff size={18} strokeWidth={1.8} /> : <Eye size={18} strokeWidth={1.8} />}
                  </button>
                </div>
              </div>
              <div className="lg-field">
                <label>Ulangi Password</label>
                <div className="lg-input">
                  <Lock className="lg-input-ic" size={18} strokeWidth={1.8} />
                  <input data-testid="reset-confirm" type={showPass ? "text" : "password"} required value={confirm}
                    onChange={(e) => setConfirm(e.target.value)} placeholder="Ketik ulang password" autoComplete="new-password" />
                </div>
              </div>
              {err && <div className="lg-err" data-testid="reset-error">{err}</div>}
              <button className="lg-submit" type="submit" disabled={busy} data-testid="reset-submit">
                {busy ? "Memproses…" : "Simpan Password Baru"}
                {!busy && <ArrowRight size={18} strokeWidth={2.4} />}
              </button>
              <button type="button" className="lg-secondary" onClick={goLogin} data-testid="reset-cancel">Batal, kembali masuk</button>
            </form>
          )}
          <div className="lg-secure"><ShieldCheck size={15} strokeWidth={2} /> Data Anda aman bersama kami.</div>
        </div>
      </main>
    </div>
  );
}
